import React, { useEffect, useState, useRef } from 'react';
import DropDown from '../../../../../components/DropDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from '../../../../../components/Modal';
import {
  faArrowDown,
  faCircleQuestion,
  faUserTimes,
  faCopy
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import AssignMenuPreviewModal from './AssignMenuPreviewModal';
import {
  useGetClassesMutation,
  useGetStudentsDetailsMutation,
  useGetClassIdMutation,
  useAddClassIdMutation
} from '../../../../../features/authentication/authApiSlice';
import { useAssignmentContext } from '../../../context';
import GoogleClassroomShareModal from '../../../../../components/GoogleClassroomShareModal/index';
import AssignmentSettings from '../../../../../components/AssignmentSettings';
import {
  useAssignStudentsMutation,
  useCreateAssignmentLinkMutation
} from '../../../../../features/authentication/assignApiSlice';
import CustomToast from '../../../../../components/Toast';
import ToastTable from '../../../../../components/ToastTable';
import { useGetUserIdMutation } from '../../../../../features/authentication/dashboardHeaderApiSlice';
import assignedVia_1 from '../../../../../assets/images/assignedVia_1.png';
import assignedVia_2 from '../../../../../assets/images/assignedVia_2.png';
import assignedVia_3 from '../../../../../assets/images/assignedVia_3.png';
import assignedVia_4 from '../../../../../assets/images/assignedVia_4.png';
import { useCheckIsSelfAssignedMutation } from '../../../../../features/authentication/assignApiSlice';
import moment from 'moment';
import TableSkeleton from '../../../../../components/SkeletonLoader/TableSkeleton';

const AssignMenuModal = ({ modalData, setModalData }) => {
  const assignedViaOptions = [
    { assignedViaId: 1, className: 'castle', name: 'Castle', image: assignedVia_1 },
    { assignedViaId: 2, className: 'google', name: 'Google Classroom', image: assignedVia_2 },
    { assignedViaId: 3, className: 'schoology', name: 'Schoology', image: assignedVia_3 },
    { assignedViaId: 4, className: 'canvas', name: 'Canvas', image: assignedVia_4 }
  ];

  const [getAllClasses] = useGetClassesMutation();
  const [getPersistClassId] = useGetClassIdMutation();
  const [addPersistClassId] = useAddClassIdMutation();
  const [getAllStudents] = useGetStudentsDetailsMutation();
  const [allAssignedData] = useAssignStudentsMutation();
  const [getUserId, getUserIdResults] = useGetUserIdMutation();
  const [selectedClassId, setSelectedClassId] = useState([]);
  const [notAssignedData, setNotAssignedData] = useState([]);
  const [previewAssignmentModal, setPreviewAssignmentModal] = useState(false);
  const [classDetails, setClassDetails] = useState([]);
  const [totalNotAssigned, setTotalNotAssigned] = useState(0);
  const [assignToSelf, setAssignToSelf] = useState(false);
  const [count, setCount] = useState(0);
  const [toastTable, setToastTable] = useState(false);
  const [assignedResponse, setAssignedResponse] = useState([]);
  const [userId, setUserId] = useState();
  const [persistClassId, setPersistClassId] = useState([]);
  const selectedAssignment = useAssignmentContext();
  const { setAssignedDataStatus, setAssignmentOptions } = useAssignmentContext();
  const [createAssignmentLinkCall] = useCreateAssignmentLinkMutation();
  const [assignmentMethodId, setAssignmentMethodId] = useState(1);
  const [showShareToGoogleClassroomModal, setShowShareToGoogleClassroomModal] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const createdAssignmentLink = useRef('');
  const [checkAllSelfAssigned] = useCheckIsSelfAssignedMutation();
  // the number of items that we want to keep in memory - 300
  // the number of items that we want to cache when new chunk of data is loaded
  const [isLoading, setIsLoading] = useState(false);
  const [modalTitle, setModalTitle] = useState('Assign Assignment(s) to Students');
  const [isAssignToSelf, setIsAssignToSelf] = useState(false);

  const getAllClassesAsync = async () => {
    try {
      const allClassesResponse = await getAllClasses().unwrap();
      const obj = {
        id: -1,
        name: 'All Classes'
      };
      const classArr = allClassesResponse.map((item) => ({
        id: item.classID,
        name: item.className,
        coteacherName: item.coTeacherClass ? item.teacherName : ''
      }));
      const classArray = [obj, ...classArr];
      setClassDetails(classArray);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedClassId) {
      loadInitialData();
    }
  }, [selectedClassId]);

  useEffect(() => {
    if (selectedAssignment.assignedData.length === 1)
      selectedAssignment.setAssignmentId(selectedAssignment.assignedData[0].assignmentId);
    getUserIdAsync();
    getClassId();
    checkIsSelfAssigned();
  }, []);

  useEffect(() => {
    if (selectedClassId) {
      loadInitialData();
      getAllClassesAsync();
    }
  }, [selectedClassId]);

  useEffect(() => {
    if (!modalData) return;
    var assignmentTitle = 'Assign Assignment(s) to Students';
    var assignedViaDetails = assignedViaOptions.find(
      (c) => c.assignedViaId == selectedAssignment.assignedData[0].assignedVia
    );

    if (selectedAssignment.assignedData.length === 1) {
      assignmentTitle = `Assign ${selectedAssignment.assignedData[0].assignmentName} to Students`;
    } else {
      assignmentTitle = 'Assign Assignments to Students';
    }
    var modalTitle = (
      <>
        {assignmentTitle}
        {assignedViaDetails && (
          <span className={`manage-assign-card manage-badge ${assignedViaDetails.className} ms-2`}>
            <span>
              <img
                src={assignedViaDetails.image}
                className="img-fluid"
                alt={`Assigned via ${assignedViaDetails.name}`}
              />
            </span>
            {assignedViaDetails.name}
          </span>
        )}
      </>
    );
    setModalTitle(modalTitle);
    setAssignmentMethodId(selectedAssignment.assignedData[0].assignedVia);
  }, [modalData]);

  const getClassId = async () => {
    const id = await getPersistClassId().unwrap();
    setSelectedClassId(id);
    setPersistClassId(id);
  };

  const loadInitialData = async () => {
    setIsLoading(true);
    const { total, data } = await getAllStudentsAsync(0, 1000);
    setNotAssignedData(data);
    setTotalNotAssigned(total);
    setIsLoading(false);
  };

  const handleSelectClass = (event) => {
    const selectedId = parseInt(event.target.value);
    setClassId(selectedId);
    setSelectedClassId(selectedId);
  };

  const setClassId = async (classId) => {
    const options = {};
    options.classId = classId;
    await addPersistClassId(options).unwrap();
  };

  const getAllStudentsAsync = async (skip, take) => {
    try {
      const options = {};
      selectedClassId !== undefined && selectedClassId !== ''
        ? (options.classId = selectedClassId)
        : persistClassId;
      if (skip !== undefined && skip !== '') options.skip = skip;
      if (take !== undefined && take !== '') options.take = take;
      if (selectedAssignment.assignedData.length > 0)
        options.aIds = selectedAssignment.assignedData.map((item) => item.assignmentId);
      if (selectedAssignment.assignedData.length === 1)
        selectedAssignment.setAssignmentId(selectedAssignment.assignedData[0].assignmentId);
      return await getAllStudents(options).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, checked } = e.target;
    let tempNotAssignedData = [];
    if (name === 'assignCheck') {
      tempNotAssignedData = notAssignedData.map((item) => {
        return { ...item, isChecked: checked };
      });
    } else {
      const id = parseInt(name);
      tempNotAssignedData = notAssignedData.map((item) =>
        item.id === id && !item.deleted ? { ...item, isChecked: checked } : item
      );
    }
    setNotAssignedData(tempNotAssignedData);
  };

  const previewAssignmentHandler = () => {
    setPreviewAssignmentModal(!previewAssignmentModal);
  };

  const handleAssignSelf = (event) => {
    const checked = event.target.checked;
    setAssignToSelf(checked);
  };

  const getUserIdAsync = async () => {
    try {
      const response = await getUserId().unwrap();
      setUserId(response.userId);
    } catch (error) {
      console.log(error);
    }
  };

  const resetAssignModal = () => {
    setSelectedClassId(-1);
    setAssignToSelf(false);
    setCount(count + 1);
    setNotAssignedData(
      notAssignedData.map((item) => {
        return { ...item, isChecked: false };
      })
    );
  };

  const validateAssignmentData = async (callback) => {
    const timedTimeSpan =
      parseInt(selectedAssignment.timedHour * 60) + parseInt(selectedAssignment.timedMinute);

    let students = [];
    if (assignToSelf) {
      students.push({ studentId: userId, classId: selectedClassId });
    }
    notAssignedData
      .filter((item) => item.isChecked === true)
      .map((data) => students.push({ studentId: data.id, classId: selectedClassId }));

    if (
      assignToSelf === false &&
      students.length <= 0 &&
      selectedAssignment.assignedData[0].assignedVia === 1
    ) {
      CustomToast('Please check at least one student in the "Not Assigned" list', 'info');
      return;
    }

    if (selectedAssignment.availabilityOption !== 'offline') {
      if (!selectedAssignment.assignmentMode) {
        CustomToast('Please select the assignment mode', 'warning');
        return;
      }
    }
    if (selectedAssignment.isTimed && timedTimeSpan <= 0) {
      CustomToast('The time length must be greater than 0 minutes.', 'info');
      return;
    }

    if (selectedAssignment.availabilityOption == 'FromTo') {
      const currentDate = moment().format('YYYY/MM/DD h:mm A'); // Get the current date/time
      if(moment(selectedAssignment.startDate).isBefore(currentDate, 'day')){
        CustomToast('From Date must not be before the current day', 'error');
        return;
      }
      if(moment(selectedAssignment.endDate).isBefore(currentDate)){
        CustomToast('To Date must not be before the current date/time', 'error');
        return;
      }
      if(moment(selectedAssignment.endDate).isBefore(moment(selectedAssignment.startDate)) || moment(selectedAssignment.endDate).isSame(moment(selectedAssignment.startDate))){
        CustomToast('To Date must be after the From Date', 'error');
        return;
      }
    }

    if (selectedAssignment.retakesEnabled) {
      if (selectedAssignment.retakeLimitValue <= 0) {
        CustomToast('You must select a retake limit', 'info');
        return;
      }
      if (selectedAssignment.retakeQuestion === null) {
        CustomToast(
          'You must select an option for Auto Graded Questions to include on Retakes',
          'info'
        );
        return;
      }
      if (selectedAssignment.includeCR === null) {
        CustomToast('You must select an option for CR Questions to include on Retakes', 'info');
        return;
      }
    }

    let options = {
      assignmentIds: selectedAssignment.assignedData.map((assignment) => {
        return assignment.assignmentId;
      }),
      students: students,
      selfAssign: assignToSelf,
      availability: selectedAssignment.availabilityOption,
      assignmentMode: selectedAssignment.assignmentMode,
      allowAnswerChange: selectedAssignment.allowAnswerChange,
      showGrade: selectedAssignment.showGrade,
      startDate: selectedAssignment.startDate,
      endDate: selectedAssignment.endDate,
      studentFileUpload: selectedAssignment.studentFileUpload,
      timed: selectedAssignment.isTimed,
      timeSpan: timedTimeSpan,
      practice: true,
      assignRetake: selectedAssignment.retakesEnabled,
      masteryLevel: selectedAssignment.masteryValue,
      retakeMode: selectedAssignment.assignmentMode,
      scoreRetries: selectedAssignment.scoreRetries,
      retakeLimit: selectedAssignment.retakeLimitValue,
      retakeAvailabilty: selectedAssignment.availabilityOption,
      retakeStartDate: selectedAssignment.startDate,
      retakeEndDate: selectedAssignment.endDate,
      retakeTimed: selectedAssignment.isTimed,
      retakeTimeSpan: timedTimeSpan,
      retakeQuestion: selectedAssignment.retakeQuestion,
      includeCR: selectedAssignment.includeCR,
      randomized: selectedAssignment.randomized,
      textToSpeech: selectedAssignment.textToSpeech,
      autoLockQuestions: selectedAssignment.autoLockQuestions,
      allowLangChange: selectedAssignment.allowLangChange,
      useCalc: selectedAssignment.calculatorEnabled ? 1 : 0,
      useProtractor: selectedAssignment.useProtractor ? 1 : 0,
      useRuler: selectedAssignment.useRuler ? 1 : 0,
      timeOnTask: selectedAssignment.timeOnTaskEnabled,
      period: selectedAssignment.timeOnTaskSeconds,
      lockBrowser: selectedAssignment.lockBrowser,
      photoMathBlock: selectedAssignment.photoMathBlock,
      autoStartCRUponGrading: selectedAssignment.autoStartCRUponGrading,
      cranswerToolId: selectedAssignment.crAnswerToolType,
      calculatorType: selectedAssignment.calculatorType
    };

    // Assignment options are valid, use callback function
    callback(options);
  };

  const createLinkAndShareToGoogle = async (assignmentOptions) => {
    assignmentOptions.students = [{ studentId: getUserIdResults.data.userId, classId: -1 }];
    setAssignmentOptions(assignmentOptions);
    setShowShareToGoogleClassroomModal(true);
  };

  const createAssignmentLink = async (assignmentOptions) => {
    try {
      assignmentOptions.students = [{ studentId: getUserIdResults.data.userId, classId: -1 }];
      setIsLoading(true);

      createdAssignmentLink.current = await createAssignmentLinkCall(assignmentOptions).unwrap();
      if (createdAssignmentLink.current.length > 1) {
        setModalData(false);
        CustomToast(
          'Assignment links have been created, you can find them under "View Assignment Links"',
          'success'
        );
      } else if (createdAssignmentLink.current.length === 1) {
        setShowLinkModal(true);
      } else {
        CustomToast('Error! Couldn\'t create assignment link', 'error');
      }
      setIsLoading(false);
    } catch (ex) {
      CustomToast('Error! Couldn\'t create assignment link', 'error');
      setIsLoading(false);
      console.log(ex);
    }
  };

  function copyLinkToClipboard(fullUrl) {
    navigator.clipboard.writeText(fullUrl);
    CustomToast('Link copied', 'info');
  }

  const assignDataHandler = async (assignmentOptions) => {
    try {
      let studentsAssignedArray = [];
      setIsLoading(true);

      const allAssignedDataResponse = await allAssignedData(assignmentOptions).unwrap();
      allAssignedDataResponse.map((item) => {
        if (item.studentsAssigned > 0) {
          studentsAssignedArray.push(item.studentsAssigned);
        }
      });
      if (allAssignedDataResponse.length > 0) {
        setToastTable(true);
        setAssignedResponse(allAssignedDataResponse);
      } else {
        setToastTable(false);
        CustomToast('Error! Couldn\'t Assign', 'error');
      }
      setIsLoading(false);

      resetAssignModal();
    } catch (ex) {
      CustomToast(ex.data, 'error');
      console.log(ex);
      setIsLoading(false);
    }
  };

  const ontoastCloseHandler = () => {
    setToastTable(false);
    setModalData(false);
    selectedAssignment.setAssignedData([]);
    setAssignedDataStatus(new Date().getSeconds());
  };

  const checkIsSelfAssigned = async () => {
    try {
      const options = {
        assignmentIds: selectedAssignment.assignedData.map((item) => item.assignmentId)
      };
      const checkSelfAssignResponse = await checkAllSelfAssigned(options).unwrap();
      if (checkSelfAssignResponse) setIsAssignToSelf(true);
    } catch (ex) {
      console.log(ex);
    }
  };
  return (
    <>
      <Modal
        contentWidth={assignmentMethodId === 1 ? '100%' : '75%'}
        isOpen={modalData}
        titleName={modalTitle}
        onClose={() => {
          setModalData(false);
          resetAssignModal();
        }}>
        <Row>
          {assignmentMethodId === 1 && (
            <Col className="col-lg-6 p-20 assign-left">
              Class
              <div className="d-flex align-items-center gap-4">
                <div>
                  <DropDown
                    label=""
                    value={classDetails}
                    selectedValue={selectedClassId}
                    onChangeHandler={(e) => handleSelectClass(e)}
                    description={true}
                  />
                </div>
                {isAssignToSelf && (
                  <div className="form-check d-flex align-items-center mt-4 assign-settings-header">
                    <span>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        name="assignToSelf"
                        id="assignToSelf"
                        checked={assignToSelf}
                        onClick={(e) => handleAssignSelf(e)}
                      />
                      <label className="form-check-label ms-2" htmlFor="assignToSelf">
                        Assign to self
                      </label>
                    </span>
                  </div>
                )}
              </div>
              <div className="my-4 gap-2">
                <span className="primary-title">Not Assigned</span> ({totalNotAssigned}){' '}
                <OverlayTrigger
                  key="tooltip-notAssigned"
                  placement="top"
                  overlay={
                    <Tooltip id="not-assigned-info" className="not-assigned-tooltip">
                      <p>
                        The following students are in the class, but you have NOT assigned these
                        assignments to them. To add students to the assignments, check the box next
                        to the names and click ASSIGN.
                      </p>
                    </Tooltip>
                  }>
                  <FontAwesomeIcon className="circle-question" icon={faCircleQuestion} />
                </OverlayTrigger>
              </div>
              {isLoading ? (
                <TableSkeleton
                  rowCount={4}
                  colCount={3}
                  tableClass={'pt-4'}
                  skeletonClass={'pt-2'}/>
              ):(
                <div className="custom-table table-responsive not-assigned-table transparent-scroll">
                  <table className="table currentlist-table">
                    <thead>
                      <tr>
                        <th>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              value=""
                              id="assignCheck"
                              name="assignCheck"
                              checked={
                                notAssignedData.filter((item) => item?.isChecked !== true).length < 1
                              }
                              onChange={handleChange}
                            />
                          </div>
                        </th>
                        <th>Last Name</th>
                        <th>First Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading === false && (
                        <>
                          {notAssignedData.length > 0 ? (
                            <>
                              {notAssignedData.map((item, index) => (
                                <tr key={`${item.id}-${index}`}>
                                  <td>
                                    {!item.deleted && (
                                      <div className="form-check">
                                        <input
                                          type="checkbox"
                                          value=""
                                          name={item.id}
                                          checked={!!item?.isChecked}
                                          onChange={handleChange}
                                          className="form-check-input"
                                          id={`flexCheckDefault-${item.id}`}
                                        />
                                      </div>
                                    )}
                                    {item.deleted && (
                                      <OverlayTrigger
                                        key="1245455"
                                        placement="right"
                                        overlay={
                                          <Tooltip id="45824582" className="tooltip-white">
                                            <h4>Deactivated</h4>
                                            <p className="mb-0">
                                            Students cannot use deactivated accounts, but teacher
                                            and administrator reports do include data for these
                                            accounts{' '}
                                            </p>
                                          </Tooltip>
                                        }>
                                        <div className="deactivated">
                                          <FontAwesomeIcon icon={faUserTimes} />
                                        </div>
                                      </OverlayTrigger>
                                    )}
                                  </td>
                                  <td className={item.deleted ? 'disable-data' : ''}>
                                    {item.lName}
                                  </td>
                                  <td className={item.deleted ? 'disable-data' : ''}>
                                    {item.fName}
                                  </td>
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colSpan={3} className="fs-6 text-center">
                              There is no more unassigned student in this class
                              </td>
                            </tr>
                          )}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </Col>
          )}
          <AssignmentSettings
            allowRetakesOption={assignmentMethodId === 1 ? true : false}
            headingDescription={true}
            availabilityRequired={true}
            modesRequired={true}
            showBetaButton={true}
            noColumn={assignmentMethodId === 1 ? false : true}
            randomizedQuestion={true}
            disabledTextSpeach={true}
            allowOfflineMode={true}
            isSelfAssign={false}
          />
        </Row>
        {assignmentMethodId === 1 && (
          <div className="scrolldown-btn">
            <span>Scroll Down</span>
            <FontAwesomeIcon icon={faArrowDown} />
          </div>
        )}
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button
            className="btn btn-castleGray print-btn"
            onClick={() => {
              resetAssignModal();
              setModalData(false);
            }}>
            Cancel
          </button>
          {selectedAssignment.assignedData?.length <= 1 && (
            <button className="btn btn-castleWhite preview-btn" onClick={previewAssignmentHandler}>
              Preview Assignment
            </button>
          )}

          {/* Assigned Via Castle */}
          {assignmentMethodId === 1 && (
            <button
              className="btn btn-castleRed print-btn"
              onClick={() => validateAssignmentData(assignDataHandler)}
              disabled={isLoading}>
              Assign
            </button>
          )}
          {/* Assigned Via 3rd Party */}
          {assignmentMethodId !== 1 && (
            <button
              className="btn btn-castleRed flex-shrink-0"
              onClick={() => validateAssignmentData(createAssignmentLink)}>
              {`Create Assignment Link${selectedAssignment.assignedData.length === 1 ? '' : 's'}`}
            </button>
          )}
          {/* Assigned Via Google Classroom */}
          {assignmentMethodId === 2 && selectedAssignment.assignedData.length === 1 && (
            <button
              className="createAndShareToGoogleBtn"
              onClick={() => validateAssignmentData(createLinkAndShareToGoogle)}>
              Create link & share to Google Classroom
            </button>
          )}
        </div>
        {/* preview modal */}
        <AssignMenuPreviewModal
          modalData={previewAssignmentModal}
          setModalData={setPreviewAssignmentModal}
        />
        {/* preview modal */}
        {toastTable && <ToastTable data={assignedResponse} onClose={ontoastCloseHandler} />}
      </Modal>

      {/* Link created modal */}
      <Modal
        contentWidth="40%"
        isOpen={showLinkModal}
        titleName={'Link Created'}
        onClose={() => {
          setShowLinkModal(false);
        }}>
        <div className="d-flex flex-column align-items-center">
          <div>
            An assignment link has been created! Click the icon below to copy it to your clipboard
            now.
          </div>

          <OverlayTrigger
            key="copyToClipboard"
            placement="top"
            overlay={<Tooltip className="custom-tooltip">Copy to Clipboard</Tooltip>}>
            <button
              className="copyLinkBtn my-3"
              onClick={() => copyLinkToClipboard(createdAssignmentLink.current[0])}>
              <FontAwesomeIcon icon={faCopy} />
            </button>
          </OverlayTrigger>

          <div>You can also find this link under &quot;View Assignment Links&quot;.</div>
        </div>
      </Modal>
      {showShareToGoogleClassroomModal &&
      <GoogleClassroomShareModal
        showShareToGoogleClassroomModal={showShareToGoogleClassroomModal}
        setShowShareToGoogleClassroomModal={setShowShareToGoogleClassroomModal}
        assignmentName={selectedAssignment.assignedData[0]?.assignmentName}
        setShowParentModal={setModalData}
      />
      }
    </>
  );
};

AssignMenuModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func
};

export default AssignMenuModal;
